<template>
  <div class="zhaopin">
    <c-tab :tabs="tabs"></c-tab>
  </div>
</template>

<script>
import CTab from '@/components/common/tab'
import JianLi from './#jianli'
import http from '@/plugins/axios'
import * as types from '@/store/mutation-types'

let numbers
export default {
  name: 'zhaopin',
  components: { CTab },
  data () {
    return {
      active: '0',
      tabs: [ {
        label: '职位',
        key: 'zhiwei',
        component: () => import('./#zhiwei')
      }, {
        label: '简历',
        key: 'jianli',
        component: JianLi
      }, {
        label: '邀约',
        key: 'jianli_yaoyue',
        component: JianLi
      }, {
        label: '爽约',
        key: 'jianli_shuangyue',
        component: JianLi
      }, {
        label: '已面试',
        key: 'jianli_mianshi',
        component: JianLi
      }, {
        label: '入职',
        key: 'jianli_ruzhi',
        component: JianLi
      }, {
        label: '储备库',
        key: 'ziyuan',
        component: JianLi
      }, {
        label: '下线职位',
        key: 'xiaxian_zhiwei',
        component: () => import('./#zhiwei-xiaxian')
      }]
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  },
  beforeRouteEnter (to, from, next) {
    http.get('/zhaopin2').then(res => {
      numbers = res.data
      next()
    })
  },
  created () {
    Object.keys(numbers).forEach(key => {
      const tab = this.tabs.find(x => `${x.key}_number` === key)
      tab && this.$set(tab, 'label', `${tab.label}(${numbers[ key ]})`)
    })
    this.$store.dispatch('fetchJobs').then(jobs => {
      this.options = jobs
    })
  }
}
</script>

<style lang="scss">
</style>
